module.exports = __webpack_public_path__ + "img/pdf.bffcc2cd.png";